import axios from "../../../../utils/request";

function GET_LIST(params) {
  return axios.get("/member/AIconLibraryCategory/index", {
    params: {
      page: params
    }
  });
}

function ADD(params) {
  return axios.get("/member/AIconLibraryCategory/add", { params: {} });
}
function ADD_POST(params) {
  return axios.post("/member/AIconLibraryCategory/addPost", { ...params });
}
function EDIT(params) {
  return axios.get("/member/AIconLibraryCategory/edit", {
    params: {
      id: params
    }
  });
}
function EDIT_POST(params) {
  return axios.post("/member/AIconLibraryCategory/editPost", { ...params });
}
function DELE(params) {
  return axios.post("/member/AIconLibraryCategory/delete", {
    ids: params
  });
}

export default {
  GET_LIST,
  ADD,
  ADD_POST,
  EDIT,
  EDIT_POST,
  DELE
};
